export default __webpack_public_path__ + "static/media/up.483ed5fc.svg";